import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const trackingCardTokenizationSuccessfully: CheckoutActionCreator = () => (dispatch) => {
  dispatch({
    type: actionTypes.CHECKOUT_CARD_TOKENIZATION_SUCCEEDED,
    trackingData: {
      actionType: 'CardTokenization Succeededs',
    },
  })
}
